/**
 * Returns the latest index of a list that is not the ignoredIndex
 * @param list
 * @param ignoredIndex
 */
export const findLatestIndex = <T>(list: T[], ignoredIndex: T | undefined): number => {
  const count = list.length - 1;
  const index = list
    .slice()
    .reverse()
    .findIndex((item) => item !== ignoredIndex);

  return index >= 0 ? count - index : index;
};

/**
 * Returns a list using an enum keys
 * @param typeEnum
 */
export const mapEnumKeyToArray = <T extends Record<string, any>>(typeEnum: T): string[] => {
  return Object.keys(typeEnum)
    .filter((key: string) => !isNaN(Number(key)))
    .map((key: string) => typeEnum[key]);
};

/**
 * Returns a list using an enum values only
 * @param typeEnum
 */
export const mapEnumValueToArray = <T extends Record<string, any>>(typeEnum: T): string[] => {
  return Object.keys(typeEnum)
    .filter((key: string) => isNaN(Number(key)))
    .map((key: string) => typeEnum[key]);
};
